export const OWNER_MANUALS_CATEGORY_FILTER_DATA_ID = 'owner-manuals_category-filter';
export const OWNER_MANUALS_SEGMENT_FILTER_DATA_ID = 'owner-manuals_segment-filter';
export const OWNER_MANUALS_MODEL_FILTER_DATA_ID = 'owner-manuals_model-filter';
export const OWNER_MANUALS_YEAR_FILTER_DATA_ID = 'owner-manuals_year-filter';
export const OWNER_MANUALS_LANGUAGE_FILTER_DATA_ID = 'owner-manuals_language-filter';
export const OWNER_MANUALS_ERROR_ALERT_ID = 'owner-manuals_error';
export var ManualKeyValues;
(function (ManualKeyValues) {
    ManualKeyValues["LANGUAGE"] = "language";
    ManualKeyValues["MODEL"] = "modelName";
    ManualKeyValues["SEGMENT"] = "segmentName";
    ManualKeyValues["YEAR"] = "year";
})(ManualKeyValues || (ManualKeyValues = {}));
export const MANUALS_WRAPPER_ID = 'manuals-wrapper-id';
